export const compressImage = (file, { maxWidth = 1920, maxHeight = 1920, quality = 0.8 } = {}) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions keeping aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        // Clear canvas to ensure transparent background is preserved
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);

        // Preserve PNG and WebP formats to maintain transparency
        let outputType = 'image/jpeg';
        if (file.type === 'image/png') {
          outputType = 'image/png';
        } else if (file.type === 'image/webp') {
          outputType = 'image/webp';
        } else if (file.type === 'image/gif') {
          outputType = 'image/gif';
        }

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(file); // Fallback to original if compression fails
              return;
            }
            const compressedFile = new File([blob], file.name, {
              type: outputType,
              lastModified: Date.now(),
            });
            resolve(compressedFile);
          },
          outputType,
          quality // Note: The quality parameter is automatically ignored by the browser for image/png
        );
      };
      img.onerror = () => resolve(file); // Fallback to original on error
    };
    reader.onerror = () => resolve(file); // Fallback to original on error
  });
};